// import { UserRequestDto } from '@gtpl/shared-models/common-models';
import { AllHsnResponseModel, HsnCodeRequestByVal, HsnResponseModel } from '@gtpl/shared-models/masters';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post, Req } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { UserRequestDto } from '../countries/dto/user-request-dto';
import { HsnCodesDTO } from './dto/hsn-codes.dto';
import { HsnCodesRequest } from './dto/hsn-codes.request';
import { HsnDataRequest } from './dto/hsn-data-request';
import { HsnRequest } from './dto/hsn.request';
import { HsnCodesService } from './hsn-codes.service';

@ApiTags('hsn-codes')
@Controller('hsn-codes')
export class HsnCodesController {
    constructor(
        private hsnCodesService: HsnCodesService,
        private readonly applicationExceptionhandler: ApplicationExceptionHandler,

    ) { }
    /**
     * create HsnCode
     * @param hsnCodesDTO 
     * @param isUpdate 
     * @param request 
     */
    @Post('/createHsnCode')
    async createHsnCode(@Body() hsnCodesDTO: HsnCodesDTO, isUpdate: boolean = false, @Req() request: Request): Promise<HsnResponseModel> {
        try {
            // console.log(hsnCodesDTO);
            return await this.hsnCodesService.createHsnCode(hsnCodesDTO, false, request);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(HsnResponseModel, error)
        }
    }
    /**
     * update HsnCode
     * @param hsnCodesDTO 
     * @param request 
     */
    @Post('/updateHsnCode')
    async updateHsnCode(@Body() hsnCodesDTO: HsnCodesDTO, @Req() request: Request): Promise<HsnResponseModel> {
        try {
            return await this.hsnCodesService.createHsnCode(hsnCodesDTO, true, request);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(HsnResponseModel, error)
        }
    }
    /**
     * get all Hsn Codes
     * @param request 
     */
    @Post('/getAllHsnCodes')
    async getAllHsnCodes(@Body() req?:UserRequestDto): Promise<AllHsnResponseModel> {
        try {
            return await this.hsnCodesService.getAllHsnCodes(req);
        } catch (error) {
            return this.applicationExceptionhandler.returnException(AllHsnResponseModel, error)
        }
    }

    @Post('/getAllActiveHsnCodes')
  async getAllActiveHsnCodes(@Req() request: Request): Promise<AllHsnResponseModel> {
      try {
          return await this.hsnCodesService.getAllActiveHsnCodes();
      } catch (error) {
          return this.applicationExceptionhandler.returnException(AllHsnResponseModel, error)
      }
  }
    /**
     * Activate or DeActivate Hsn Codes
     * @param HsnCodeReq 
     */
    @Post('/activateOrDeactivateHsnCode')
    async activateOrDeactivateHsnCode(@Body() HsnCodeReq: HsnCodesRequest): Promise<HsnResponseModel> {
        try {
            return await this.hsnCodesService.activateOrDeactivateHsnCode(HsnCodeReq);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(HsnResponseModel, err);
        }
    }

    /**
     * 
     * @param req FoodType, ValOne, ValTwo, ValThree, ValFour, ValFive, ProductId
     * @returns HSN Code
     */
    @Post('/getHsnByFoodType')
    async getHsnByFoodType(@Body() req: HsnRequest): Promise<HsnResponseModel> {
        try {
            return await this.hsnCodesService.getHsnByFoodType(req);
        } catch (err) {
            return this.applicationExceptionhandler.returnException(HsnResponseModel, err);
        }
    }
}
